export const CHECKOUT_URL = "https://checkout.razorpay.com/v1/checkout.js";

/**
 * Loads Razorpay's checkout script once and resolves with window.Razorpay.
 * A failed or timed-out load removes its <script> tag, so the next call starts fresh
 * instead of waiting for events that already fired.
 */
export function loadRazorpay({ timeoutMs = 15000 } = {}) {
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  return new Promise((resolve, reject) => {
    let script = document.querySelector(`script[src="${CHECKOUT_URL}"]`);
    if (script && script.dataset.status === "loaded") {
      // It loaded but Razorpay isn't defined (e.g. blocked), so try again.
      script.remove();
      script = null;
    }
    if (!script) {
      script = document.createElement("script");
      script.src = CHECKOUT_URL;
      script.async = true;
      script.dataset.status = "loading";
      document.body.appendChild(script);
    }
    const current = script;
    let timer;

    function cleanup() {
      clearTimeout(timer);
      current.removeEventListener("load", onLoad);
      current.removeEventListener("error", onError);
    }
    function fail(message) {
      cleanup();
      current.remove();
      reject(new Error(message));
    }
    function onLoad() {
      cleanup();
      current.dataset.status = "loaded";
      if (window.Razorpay) resolve(window.Razorpay);
      else fail("Razorpay checkout loaded but is not available");
    }
    function onError() {
      fail("Razorpay checkout failed to load");
    }

    current.addEventListener("load", onLoad);
    current.addEventListener("error", onError);
    timer = setTimeout(() => fail("Razorpay checkout took too long to load"), timeoutMs);
  });
}
